"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var customerComboWrapper = void 0;
    var selectElement = void 0;
    var addRoleButton = document.getElementById('add-role-btn');
    if (!addRoleButton || addRoleButton.validateRegistered) return;

    addRoleButton.addEventListener('click', registerAddRoleValidation);
    addRoleButton.validateRegistered = true;

    function registerAddRoleValidation() {
        window.setTimeout(function () {
            var saveRoleButton = document.querySelector('#role-modal #add-role-submit-button');
            customerComboWrapper = document.querySelector('#role-modal #customer-select');
            selectElement = customerComboWrapper.querySelector('select#CustomerId');

            if (saveRoleButton && customerComboWrapper && selectElement && !saveRoleButton.validateRegistered) {
                saveRoleButton.addEventListener('click', saveButtonClick);
                saveRoleButton.validateRegistered = true;
            }
        }, 1000);
    }

    function saveButtonClick() {
        var disabledContainer = customerComboWrapper.querySelector('.select2-container--disabled');
        if (!selectElement.value && !disabledContainer) _common2.default.createElement('span', customerComboWrapper, {
            className: 'field-validation-error customer-validation-error',
            'data-valmsg-replace': true,
            textContent: resx.Validation.FieldIsRquired
        });else if (selectElement.value) {
            var customerValidationElement = customerComboWrapper.querySelector('.customer-validation-error');
            if (customerValidationElement) customerValidationElement.parentElement.removeChild(customerValidationElement);
        }
    }
};

var _common = require("../utils/common");

var _common2 = _interopRequireDefault(_common);

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Validation");


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/userDetailValidation.js
// module id = 408
// module chunks = 0